import React, { Fragment } from "react"

import { moment, scale } from "utils"
import PlSeparator from "./PlSeparator"

const PlTableMovedPrintTemplate = (props) => {
  const {
    forPos,
    templateType,
    printData,
    printerWidth
  } = props

  const {
    date,
    originTableNumber,
    movedOrderCodes,
    destinationTableNumber
  } = printData

  const styles =
    templateType === "thermal" ? stylesThermal(printerWidth) : stylesOther

  return (
    <Fragment>
      <div style={styles["container"]}>
        <div style={styles["header"]}>
          (جا به جایی میز)
        </div>

        <div style={styles["text"]}>
          تاریخ ایجاد سفارش: {moment(date).format("jYYYY/jMM/jDD - HH:mm")}
        </div>

        {movedOrderCodes.map(movedOrderCode =>
          <div
            key={movedOrderCode}
            style={styles["text"]}
          >
            سفارش:{" "}
            <b style={styles["text"]}>
              {movedOrderCode}
            </b>
          </div>
        )}

        <div style={styles["text"]}>
          میز مبدا:{" "}
          <b style={styles["bold"]}>
            {originTableNumber}
          </b>
        </div>

        <div style={styles["text"]}>
          میز مقصد:{" "}
          <b style={styles["bold"]}>
            {destinationTableNumber}
          </b>
        </div>
      </div>

      <PlSeparator
        forPos={forPos}
        templateType={templateType}
      />
    </Fragment>
  )
}

const stylesThermal = (printerWidth) => ({
  container: {
    fontSize: scale("19px", printerWidth),
  },

  header: {
    textAlign: "center",
    marginBottom: scale("4px")
  },
  text: {
    textAlign: "center",
    marginBottom: scale("4px")
  },
  bold: {
  }
})

const stylesOther = {
  container: {
    marginRight: "8px",
    fontSize: "11px"
  },
  header: {
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: "4px"
  },
  text: {
    textAlign: "center",
    marginBottom: "4px"
  },
  bold: {
    fontWeight: "bold"
  }
}

export default PlTableMovedPrintTemplate